var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTiktok(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 16,
    viewBox: "0 0 13 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1031 3.15947C9.56768 2.54823 9.27262 1.76326 9.27284 0.950684H6.85258V10.6631C6.83391 11.1887 6.61202 11.6865 6.23362 12.0517C5.85522 12.417 5.34986 12.6211 4.82394 12.6212C3.71172 12.6212 2.78747 11.7126 2.78747 10.5847C2.78747 9.23755 4.08768 8.22714 5.42705 8.64227V6.16718C2.72481 5.80688 0.359375 7.90601 0.359375 10.5847C0.359375 13.193 2.52117 15.0493 4.81611 15.0493C7.27554 15.0493 9.27284 13.052 9.27284 10.5847V5.65806C10.2543 6.36287 11.4326 6.74103 12.6408 6.73896V4.31869C12.6408 4.31869 11.1683 4.38918 10.1031 3.15947Z",
    fill: "#DADADA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktok);
export default __webpack_public_path__ + "static/media/tiktok.ea20153b1632f4a120f3b78d06d66c1a.svg";
export { ForwardRef as ReactComponent };